<template>
  <v-popup @close="$emit('close')">
    <div class="discard-changes-popup">
      <img class="discard-changes-popup__img" src="~@/assets/remove-medicine-icon.svg" />
      <p class="discard-changes-popup__text-top">
        {{ $t("page.order.discard.title") }}
      </p>
      <p class="discard-changes-popup__text-bottom">
        {{ $t("page.order.discard.description") }}
      </p>
      <div class="discard-changes-popup__buttons">
        <v-button class="button--white-border" @click="$emit('close')">
          <img src="~@/assets/icons/icon-cancel.svg" class="icon-left" />
          {{$t("common.cancel")}}
        </v-button>
        <v-button primary @click="$emit('discard')">
          <img src="~@/assets/icons/icon-trash.svg" class="icon-left" />
          {{ $t("common.continue") }}
        </v-button>
      </div>
    </div>
  </v-popup>
</template>

<script>
import { VPopup, VButton } from "shared";
export default {
  name: "VOrderDiscardPopup",
  components: {
    VPopup,
    VButton
  }
};
</script>

<style lang="scss" scoped>
::v-deep .popup {
  &__container {
    min-width: 0;
    padding: 75px 0 45px 0;
    width: 443px;
  }
}
.discard-changes-popup {
  text-align: center;
  &__img {
    margin: 0 0 35px 0;
  }
  &__text-top {
    margin: 0 0 16px 0;
    font-size: 16px;
    line-height: 17px;
    text-align: center;
    color: #333333;
  }
  &__text-bottom {
    font-size: 13px;
    line-height: 16px;
    letter-spacing: 0.464286px;
    color: #333333;
    max-width: 290px;
    margin: 0 auto;
  }
  &__buttons {
    margin: 50px 0 0 0;
    display: flex;
    justify-content: center;
    .button {
      margin: 0 5px;
      padding: 11px 20px 11px 35px;
    }
  }
  strong {
    font-weight: bold;
  }
}
</style>
